import React, { createContext, useState, useEffect } from 'react';
import { GraphQLClient } from 'graphql-request';
import { routes } from 'constants/config';
import useSkillsToken, { SKILLS_TOKEN_STATES } from '../hooks/useSkillsToken';

export const SkillsClientContext = createContext({});
SkillsClientContext.displayName = 'SkillsClientContext';

export const SKILLS_CLIENT_STATES = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

export default function SkillsClientProvider({ children }) {
  const [client, setClient] = useState(
    new GraphQLClient(routes.SKILLS.GRAPHQL),
  );
  const [status, setStatus] = useState(SKILLS_CLIENT_STATES.LOADING);
  const [error, setError] = useState(null);

  const { token, error: tokenError, status: tokenStatus } = useSkillsToken();

  useEffect(() => {
    if (tokenError !== null) {
      setError(tokenError);
      setStatus(SKILLS_CLIENT_STATES.ERROR);
    }
  }, [tokenError]);

  useEffect(() => {
    if (tokenStatus !== SKILLS_TOKEN_STATES.SUCCESS) return;

    const clientCopy = client.setHeader('Authorization', `Bearer ${token}`);
    setClient(clientCopy);
    setStatus(SKILLS_CLIENT_STATES.SUCCESS);
  }, [token, client, tokenStatus]);

  return (
    <SkillsClientContext.Provider value={{ client, status, error }}>
      {children}
    </SkillsClientContext.Provider>
  );
}

export function withSkillsClientWrapper(Component) {
  const SkillsClientWrapper = props => (
    <SkillsClientProvider>
      <Component {...props} />
    </SkillsClientProvider>
  );

  return props => <SkillsClientWrapper {...props} />;
}
